<template>
    <div class="overlay" ref="overlay">
        <div class="overlay_inner_wrapper">
            <div class="page_content">
                <Case v-if="type == 'case'" :content=content />
                <AboutPage v-if="type == 'about'" />
                <PollPage v-if="type == 'poll'" :content=content />
            </div>
        </div>
    </div>
</template>

<script>
    import Case from '../views/Case'
    import PollPage from '../views/Poll'
    import AboutPage from '../views/About'

    export default {
        name: "Overlay",
        components: { AboutPage, Case, PollPage },
        props: { },
        data: () => ({
            type:'', content:{}
        }),
        created(){
            let self = this
            this.$root.$on('showOverlay', data => {
                self.type = data.type
                self.content = data.content
                self.show()
            })
            this.$root.$on('hideOverlay', data => self.hide())
        },
        methods: {
            show(){
                document.body.style.overflowY = 'hidden'
                this.$refs.overlay.classList.add('open')
                    document.querySelector('.overlay').scrollTo({
                        top:0, behavior:"smooth"
                    })
            },
            hide(){
                let self = this
                document.body.style.overflowY = 'visible'
                self.$refs.overlay.classList.remove('open')
                this.$root.$emit('setNav', false)
            }
        }
    }
</script>

<style lang="scss">
    .overlay {
        position:fixed; z-index:-1; width:0px; height:0px; top:0; left:0; background:#fff; opacity:0; transition:opacity .2s ease;
        &.open { width:100vw; height:100vh; opacity:1; z-index:4; transition:opacity .2s ease; overflow-y:scroll }

        .overlay_inner_wrapper { padding:80px 0; }

        .page_header {
            display:flex; align-items:end;
            .back_btn {
                position:relative; text-indent:-9999px; width:52px;
                &:after {
                    position:absolute; content:""; left:0; top:4px; border-style:solid; border-width:15px 15px 15px 0; border-color:transparent $yellow transparent transparent
                }
            }
        }
    }
</style>